import type { IceText } from '@wpt/iceeditor';
import { useContext, useEffect, useState } from 'react';
import { selectors as envSelectors } from 'wpt-duck-env';
import { AppContext } from '../../AppContext';
import { getIceTexts } from '../api/texts';

export const useTexts = () => {
  const { state } = useContext(AppContext);
  const [texts, setTexts] = useState<IceText[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const host: string = envSelectors.getHost(state);

  useEffect(() => {
    if (host.indexOf('undefined') !== -1) return;
    const loadData = async () => {
      setIsLoading(true);
      try {
        const result = await getIceTexts(host);
        setTexts(result);
      } catch (e) {
        console.error('Failed to load texts!', e);
        setTexts(null);
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, [host]);

  return { texts, isLoading };
};
